<div
  class="FormGroupArrayFooter"
  [ngClass]="{
    FormGroupArrayFooter__Below: config?.isFooterBelowContent,
    'u-justifyCenter': config?.showFormWithAccordion,
    'u-justifyEnd': !config?.showFormWithAccordion,
  }"
>
  @if (!config.hideActions) {
    @if (hideAddButton()) {
      <zip-button
        [config]="config.addButton"
        (zipButtonClicked)="addFormGroup()"
      >
      </zip-button>
    }
  }
</div>
